import React from "react";
import { Modal, Table, Button } from "antd";
import { observer } from "mobx-react";

export const SelectCommunityDlg = observer(({ visible, communities, onSelected, onClose }) => {
  const columns = [
    {
      title: "State",
      dataIndex: "state",
      key: "state",
    },
    {
      title: "Community Name",
      dataIndex: ["name"],
      key: "name",
    },
    {
      key: "opt",
      render: (_, r) => (
        <Button size="small" onClick={() => onSelected(r.id)}>
          Select
        </Button>
      ),
    },
  ];
  return (
    <Modal title="Select communities" visible={true} maskClosable={false} onCancel={() => onClose()} onOk={() => {}}>
      <Table size="small" rowKey="id" columns={columns} dataSource={communities} />
    </Modal>
  );
});
